(function () {
  function nextIndex(current, count) {
    if (!Number.isFinite(current) || count < 2) return 0;
    return (current + 1) % count;
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { nextIndex };
    return;
  }

  function mount(root, opts) {
    const slides = [...root.querySelectorAll('[data-bf-ann-slide]')];
    if (slides.length < 2 || root.dataset.bfAnnMounted) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.dataset.bfAnnMounted = '1';
    const interval = (opts && opts.interval) || 5000;
    let current = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    let paused = false;
    const show = (i) => slides.forEach((s, n) => {
      s.classList.toggle('is-active', n === i);
      s.setAttribute('aria-hidden', n === i ? 'false' : 'true');
    });
    setInterval(() => {
      if (paused) return;
      current = nextIndex(current, slides.length);
      show(current);
    }, interval);
    ['mouseenter', 'focusin'].forEach((e) => root.addEventListener(e, () => { paused = true; }));
    ['mouseleave', 'focusout'].forEach((e) => root.addEventListener(e, () => { paused = false; }));
  }

  const init = () => document.querySelectorAll('[data-bf-ann]').forEach((el) => mount(el));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
